import {
  NBS_API_UPLOAD_IMAGE_REQUEST,
  NBS_API_UPLOAD_IMAGE_SUCCESS,
  NBS_API_UPLOAD_IMAGE_FAILURE,
  CLEAR_IMAGE_UPLOAD_ERROR
} from '../../constants/actions';

const initialState = {
  isFetching: null,
  error: null,
  timestamp: null,
  response: {},
  status: null
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_UPLOAD_IMAGE_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'request'
      };
    case NBS_API_UPLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        response: action.response,
        timestamp: new Date().toUTCString(),
        status: 'success'
      };
    case NBS_API_UPLOAD_IMAGE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'fail'
      };
    case CLEAR_IMAGE_UPLOAD_ERROR:
      return {
        ...state,
        error: null,
        response: {},
        timestamp: new Date().toUTCString(),
        status: null
      };
    default:
      return state;
  }
}
